import React, { memo } from "react";
import Button from "react-bootstrap/Button";
import "./styles.scss";

const StyledOutlineButton = ({
  btnText,
  onClick = () => {},
  style = {},
  disabled = false,
  variant = "outline-primary",
}) => {
  return (
    <Button
      disabled={disabled}
      style={style}
      className="styled-button-styles"
      onClick={onClick}
      variant={variant}
    >
      {btnText}
    </Button>
  );
};

export default memo(StyledOutlineButton);
